import { createContext } from 'react';
import type { ActivitiesMetadata } from '../api';

type ActivitiesMetadataContext = {
  metadata: ActivitiesMetadata | undefined;
  load: (options: { signal: AbortSignal }) => Promise<void>;
  isLoading: boolean;
};

export default createContext<ActivitiesMetadataContext>({
  metadata: undefined,
  load: async () => { },
  isLoading: false,
});
